import { Component, OnInit } from '@angular/core';
import { IConfiguration } from '@bciti/types';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss'],
})
export class ConfigurationComponent implements OnInit {
    constructor(private configService: ConfigurationService) {}

    displayedColumns: string[] = ['Organisation', 'Key', 'Visibility'];
    configurations: IConfiguration<any>[];
    selectedConfig: Partial<IConfiguration<any>> = {};

    ngOnInit(): void {
        this.getConfigs();
    }

    getConfigs(): void {
        this.configService.getConfigs().subscribe((configurations) => (this.configurations = configurations));
    }

    get formattedJsonDev() {
        return this.selectedConfig.data?.dev;
    }

    get formattedJsonUat() {
        return this.selectedConfig.data?.uat;
    }

    onSelect(configuration: IConfiguration<any>): void {
        this.selectedConfig = configuration;
    }
}
